import axios from 'axios';
import cookies from 'js-cookie';
import api from '@/api';

const matrixApi = axios.create({
  baseURL: process.env.VUE_APP_MATRIX_API_URL,
});

matrixApi.interceptors.request.use(async (config) => {
  let tokenMatrix = cookies.get('tokenMatrix');
  if (!tokenMatrix) {
    const responseToken = await api.post('chat/login');
    tokenMatrix = responseToken.data.token;

    const expirationToken = new Date(new Date().getTime() + 14 * 60 * 1000);
    cookies.set('tokenMatrix', tokenMatrix, { expires: expirationToken });
  }

  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = `Bearer ${tokenMatrix}`;

  return config;
}, error => Promise.reject(error));

export default matrixApi;
